/*Bug #755 - added by Aby Joseph on 23 Feb 2022*/
import { tryLogout } from "./authenticationSlice";
import local from 'store2'; 
import { signOutUser } from "api";
import { store } from '../store';

  export const logoutAction = () => new Promise<any>((resolve, reject) => {
    const dispatch = store.dispatch;
    const {pAU, account} = store.getState().authentication;
    signOutUser(pAU).then(() => {
      
        signOutRedux(dispatch);
      resolve(true)
   
  }).catch(() => {
    reject();
  })
    
  });

  const signOutRedux=(dispatch)=>{
    dispatch(tryLogout());
    local.clearAll();
  }
/*Bug #755 - End*/

  